<template>
    <v-data-table
        :headers="realHeaders"
        :items="list"
        class="elevation-1"
        :items-per-page="-1"
        hide-default-footer
    >
        <template #item="row">
            <tr>
                <td v-for="(header, i) in realHeaders.slice(0, -1)" :key="i">
                    {{ getCellValue(row.item, header) }}
                </td>
                <td style="text-align: right;">
                    <v-btn icon color="primary" @click="editItem(row.item)">
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn icon color="primary" @click="deleteItem(row.item)">
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </td>
            </tr>
        </template>
    </v-data-table>
</template>

<script lang="ts">
import Component from 'vue-class-component'
import {TableHeader} from '@/components/common/TableHeader'
import {DeviceGroup} from '@/models/DeviceGroup'
import Browser from '@/mixins/Browser'

type Header = TableHeader<DeviceGroup>

@Component
export default class DeviceGroupBrowser extends Browser<DeviceGroup>
{
    defaultHeaders: Header[] = [
        {text: 'ID', value: 'id', align: 'start'},
        {text: 'Название', value: 'name'},
        {text: '', value: null},
    ]

    async fetchList() {
        this.list = await this.api.listDeviceGroups(this.filters)
    }

    getModelDeletedWord(): string {
        return 'удалена'
    }

    getModelDisplayName(isSecondCase: boolean): string {
        return isSecondCase ? 'группу' : 'группа'
    }

    getModelDisplayId(group: DeviceGroup): string {
        return `"${group.name}"`
    }

    async deleteModel(group: DeviceGroup): Promise<boolean> {
        return await this.api.deleteDeviceGroup(group.id)
    }
}
</script>
